import { render, staticRenderFns } from "./switchPageOneDialog.vue?vue&type=template&id=e675ca3a&"
import script from "./switchPageOneDialog.vue?vue&type=script&lang=js&"
export * from "./switchPageOneDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchPageOneDialog.vue?vue&type=style&index=0&id=e675ca3a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports